module.exports = ".slick-slide .card-body {\n  overflow-y: scroll;\n  height: 150px; }\n\n.lead-title {\n  font-weight: bold; }\n"